import React from "react";
import { useSelector } from "react-redux";
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";

import { Container, Row, Col, CardBody, Card, Button } from "reactstrap";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";

//i18n
import { withTranslation } from "react-i18next";

const LockScreen = ({ t }) => {
  const name = useSelector((state) => state.Login.data.user.name);
  const img = useSelector((state) => state.Login.data.user.url_avatar);

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col xs="7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Lock screen")}</h5>
                        <p>{t("Enter your password to unlock the screen!")}</p>
                      </div>
                    </Col>
                    <Col xs="5" className="align-self-end">
                      <img
                        src={profileImg}
                        alt="main-pic"
                        className="img-fluid"
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm className="form-horizontal">
                      <div className="user-thumb text-center mb-4">
                        <img
                          src={img}
                          className="rounded-circle img-thumbnail avatar-md"
                          alt="profil-pic"
                        />
                        <h5 className="font-size-15 mt-3">{name}</h5>
                      </div>

                      <div className="form-group">
                        <AvField
                          name="password"
                          label={t("Password")}
                          type="password"
                          required
                          placeholder={t("Enter your Password")}
                        />
                      </div>

                      <div className="form-group row mb-0">
                        <Col xs="12" className="text-right">
                          <Button
                            color="primary"
                            className=" w-md waves-effect waves-light"
                            type="submit"
                          >
                            {t("Unlock")}
                          </Button>
                        </Col>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Not you ? return")}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login{" "}
                  </Link>{" "}
                </p>
                <div className="mt-5 text-center">
                  <p>© {new Date().getFullYear()} Tech4humans.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(LockScreen);
